import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { IPC_CHANNELS } from '../../../../electron-utils/electron.model';
import { ElectronService, IncomingCallElectronModel, NetWorkType } from '../../core/services';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'incoming-call',
  templateUrl: './incoming-call.component.html',
  styleUrls: ['./incoming-call.component.scss']
})
export class IncomingCallComponent implements OnInit {

  public call: IncomingCallElectronModel;

  public call$: BehaviorSubject<IncomingCallElectronModel> = new BehaviorSubject<IncomingCallElectronModel>(null);

  constructor(
    private electronService: ElectronService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.call = JSON.parse(
      window.history.state.args.find((a: string) => a.includes("callId"))
    );
    this.call$.next(this.call);
    this.electronService.ipcRenderer.on(IPC_CHANNELS.UPDATE_INCOMING_CALL, (event, ...args: any[]) => {
      if(args[0]) {
        this.call = JSON.parse(args[0]);
        this.call$.next(this.call);
        this.changeDetectorRef.detectChanges();
      } 
    });
    this.electronService.ipcRenderer.send(IPC_CHANNELS.READY_TO_UPDATE, this.call.callId);
  }

  public onAccept(): void {
    if(this.electronService.isElectron) {
      this.electronService.ipcRenderer.send(IPC_CHANNELS.ACCEPT_INCOMING_CALL, this.call.callId);
    }
  }

  public onReject(): void {
    if(this.electronService.isElectron) {
      this.electronService.ipcRenderer.send(IPC_CHANNELS.REJECT_INCOMING_CALL, this.call.callId);
    }
  }

  public get isWhatsAppCall(): boolean {
    return this.call.networkType === NetWorkType.WHATSAPP;
  }

}
